import { render, staticRenderFns } from "./Mortgage.vue?vue&type=template&id=56f4c286"
import script from "./Mortgage.vue?vue&type=script&lang=js"
export * from "./Mortgage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports